import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AlertsService } from '../../../services/alert/alerts.service';

@Component({
  standalone: false,
  selector: 'gains-alert-banner',
  templateUrl: './alert-banner.component.html',
  styleUrls: ['./alert-banner.component.scss']
})
export class AlertBannerComponent implements OnInit {
  @Input() clientId!: string;
  @Input() environmentId!: string;

  openAlertsCount = 0;

  constructor(
    private readonly _alertsService: AlertsService,
    private readonly _router: Router
  ) {}

  ngOnInit(): void {
    if (this.clientId && this.environmentId) {
      this.checkOpenAlerts();
    }
  }

  checkOpenAlerts(): void {
    this._alertsService.getOpenAlertsCount(this.clientId, this.environmentId).subscribe({
      next: count => (this.openAlertsCount = count),
      error: () => (this.openAlertsCount = 0)
    });
  }

  navigateToAlertPage(): void {
    this._router.navigate(['/alert'], {
      state: {
        ClientId: this.clientId,
        EnvironmentId: this.environmentId,
        Status: 'OPEN'
      }
    });
  }
}
